import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import './assets/index.css';
import LoginPage from './modules/auth/pages/login-page';
import ForgotPasswordPage from './modules/auth/pages/forgot-password-page';
import ResetPasswordPage from './modules/auth/pages/reset-password-page';
import HomePage from './modules/auth/pages/home-page';
import { HelpPage } from './modules/help/pages/help-page';

export default function AuthApp() {
  return (
    <BrowserRouter>
      <AppProvider i18n={enTranslations}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/password/reset" element={<ForgotPasswordPage />} />
          <Route
            path="/password/reset/:token"
            element={<ResetPasswordPage />}
          />

          {/* Public Help Center Routes */}
          <Route path="/help-center" element={<HelpPage />} />
          <Route path="/help-center/:category/:slug" element={<HelpPage />} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
}
